var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.75H21V19.25H7V15.75ZM7 22.75H21V26.25H7V22.75ZM7 8.75H10.5V12.25H7V8.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8302 11.5255C27.7472 11.3356 27.631 11.162 27.4873 11.0128L16.9872 0.51275C16.838 0.368956 16.6644 0.252818 16.4745 0.16975C16.422 0.14525 16.366 0.13125 16.31 0.112C16.1635 0.0623519 16.0111 0.0323407 15.8567 0.02275C15.82 0.01925 15.7867 0 15.75 0H3.5C1.56975 0 0 1.56975 0 3.5V31.5C0 33.4302 1.56975 35 3.5 35H24.5C26.4303 35 28 33.4302 28 31.5V12.25C28 12.2133 27.9807 12.18 27.9772 12.1415C27.9677 11.9871 27.9376 11.8347 27.888 11.6882C27.8717 11.6322 27.8524 11.578 27.8302 11.5255ZM22.0255 10.5H17.5V5.9745L22.0255 10.5ZM3.5 31.5V3.5H14V12.25C14 12.7141 14.1844 13.1592 14.5126 13.4874C14.8408 13.8156 15.2859 14 15.75 14H24.5L24.5035 31.5H3.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSao);
export default __webpack_public_path__ + "static/media/SAO.ad41226e83b108cf09e24255905c7f9b.svg";
export { ForwardRef as ReactComponent };